import React from 'react';
import PropTypes from 'prop-types';

const Pill = ({ alt, image, text, withGradient, onClick }) => {
  const content = (
    <>
      <img src={image} alt={alt} />
      {!text ? null : <h2 className='u-text-white'>{text}</h2>}
    </>
  );
  const classNames = ['c-pill', onClick && 'c-pill--clickable', withGradient && 'c-pill--gradient']
    .filter(Boolean)
    .join(' ');

  const commonProps = {
    className: classNames
  };

  return onClick ? (
    <button {...commonProps} onClick={onClick}>
      {content}
    </button>
  ) : (
    <figure {...commonProps}>{content}</figure>
  );
};

Pill.propTypes = {
  alt: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  text: PropTypes.string,
  withGradient: PropTypes.bool
};

export default Pill;
